import React, { useState, useEffect, useRef } from "react";

import {
	Toast,
	InputNumber,
	Dialog,
	Dropdown,
	AutoComplete,
} from "../../components/crud";
import { Conexion } from "../../service/Conexion";
import { TablaDatos } from "../../components/crud/tabla/TablaDatos";
import { BarraSuperior } from "../../components/crud/tabla/BarraSuperior";
import { EliminarVentana } from "../../components/crud/EliminarVentana";

import {
	codeBodyTemplate,
	productDialogFooter,
	findIndexById,
} from "../../components/crud/tabla/Funciones";
import { ItemsCapitulodetalle } from "./ItemsCapitulodetalle";

export const MaterialCapitulo = ({
	listaMateriales,
	listaPlantillas,
	capitulo,
}) => {
	const {
		cod_bom_cbo: codigoBom,
		cod_cbo: codigoCapitulo,
		nom_cap: tipo,
		can_cbo: cantidad,
		nom_cbo: nombre,
	} = capitulo;

	let emptyProduct = {
		id: null,
		codigoCapitulo: codigoCapitulo,
		codigomaterial: 0,
		cantidad: 0,
		precio: 0,
		codigoBom: codigoBom,
		codigoPlantilla: 0,
	};
	const TABLA = "cuerpobomdetalle";
	// const titulo = "Materiales";

	const [productDialog, setProductDialog] = useState(false);
	// const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	const [product, setProduct] = useState(emptyProduct);
	const [submitted, setSubmitted] = useState(false);
	const toast = useRef(null);

	const [datostabla, setdatostabla] = useState(null);
	const [dropdownValues, setdropdownValues] = useState(null);
	const datatable = new Conexion();

	let [tipoMaterial, settipoMaterial] = useState();
	const [valueDropdownPlnatillas, setvalueDropdownPlnatillas] = useState(
		null
	);
	const [filterDropdownPlnatillas, setfilterDropdownPlnatillas] = useState();
	const [tableDropdownPlnatillas, settableDropdownPlnatillas] = useState(
		listaPlantillas
	);

	const [valueDropdownMateriales, setvalueDropdownMateriales] = useState(
		null
	);
	const [filterDropdownMateriales, setfilterDropdownMateriales] = useState();
	const [tableDropdownMateriales, settableDropdownMateriales] = useState(
		listaMateriales
	);

	const [cantidadMaterial, setcantidadMaterial] = useState(0);

	useEffect(() => {
		// datatable.gettable(TABLA).then((data) => setdatostabla(data));
		// datatable.gettable("parametros/unidades").then((unidades) => {
		// 	setdropdownValues(unidades);
		// });
		// console.log({productDialog})
	}, [productDialog]);

	const openNew = () => {
		setProduct(emptyProduct);
		setSubmitted(false);
		setProductDialog(true);
	};

	const hideDialog = () => {
		setSubmitted(false);
		setProductDialog(false);
	};

	// const hideDeleteProductDialog = () => {
	// 	setDeleteProductDialog(false);
	// };

	const saveProduct = () => {
		setSubmitted(true);

		console.log(product);

		let resultado = "";
		// let _products = [...datostabla];
		// let _product = { ...product };
		// return false;
		// console.log(_product);
		// return false;
		if (product.codigomaterial > 0 || product.codigoPlantilla > 0) {
			if (product.id == null) {
				// console.log({TABLA})
				resultado = datatable.getCrearItem(TABLA, product);
				// debugger
				// _products = [...datostabla];
				// _product = { ...product };
				// _products.push(_product);
				// setdatostabla(_products);
			} else {
				// resultado = datatable.getEditarItem(TABLA, product, product.id);
				// const index = findIndexById(product.id, datostabla);
				// _products[index] = _product;
			}
			resultado.then((value) => {
				toast.current.show({
					severity: "success",
					summary: "Confirmacion",
					detail: "Transacción Exitosa",
					life: 4000,
				});
				setProductDialog(false);
				setProduct(emptyProduct);
				settipoMaterial(0);
			});
		}
	};

	// const saveProduct = () => {
	// 	setSubmitted(true);
	// 	let resultado = "";
	// 	let _products = [...datostabla];
	// 	let _product = { ...product };
	// 	console.log(_product);
	// 	// return false;
	// 	if (product.descripcion.trim()) {
	// 		if (product.id == null) {
	// 			resultado = datatable.getCrearItem(TABLA, product);
	// 			_products = [...datostabla];
	// 			_product = { ...product };
	// 			_products.push(_product);
	// 			setdatostabla(_products);
	// 		} else {
	// 			resultado = datatable.getEditarItem(TABLA, product, product.id);
	// 			const index = findIndexById(product.id, datostabla);
	// 			_products[index] = _product;
	// 		}
	// 		resultado.then((value) => {
	// 			toast.current.show({
	// 				severity: "success",
	// 				summary: "Confirmacion",
	// 				detail: "Transacción Exitosa",
	// 				life: 4000,
	// 			});
	// 			setProductDialog(false);
	// 			setProduct(emptyProduct);
	// 		});
	// 	}
	// };

	// const editProduct = (product, id) => {
	// 	// console.log(product, id, 'edit-pro');
	// 	setProduct({ ...product });
	// 	datatable.getItem(TABLA, id).then((data) => setProduct(data.data));
	// 	// console.log(product, 'consulta');
	// 	setProductDialog(true);
	// };

	// const confirmDeleteProduct = (product) => {
	// 	setProduct(product);
	// 	setDeleteProductDialog(true);
	// };

	// const deleteProduct = () => {
	// 	let _products = datostabla.filter((val) => val.id !== product.id);
	// 	setdatostabla(_products);
	// 	let resultado = datatable.getEliminarItem(TABLA, product, product.id);
	// 	resultado.then((value) => {
	// 		setDeleteProductDialog(false);
	// 		setProduct(emptyProduct);
	// 		toast.current.show({
	// 			severity: "success",
	// 			summary: "Confirmacion",
	// 			detail: "Transacción Exitosa",
	// 			life: 4000,
	// 		});
	// 	});
	// };

	// const onInputChange = (e, name) => {
	// 	const val = (e.target && e.target.value) || "";
	// 	let _product = { ...product };
	// 	_product[`${name}`] = val;

	// 	setProduct(_product);
	// };

	const onInputNumberChange = (e, name) => {
		const val = e.value || 0;
		let _product = { ...product };
		_product[`${name}`] = val;

		setProduct(_product);
	};

	// const actionBodyTemplate = (rowData) => {
	// 	return (
	// 		<div
	// 			className="actions"
	// 			style={{
	// 				display: "flex",
	// 			}}
	// 		>
	// 			<Button
	// 				icon="pi pi-pencil"
	// 				className="p-button-rounded p-button-success mr-2"
	// 				onClick={() => editProduct(rowData, rowData.id)}
	// 			/>
	// 			<Button
	// 				icon="pi pi-trash"
	// 				className="p-button-rounded p-button-warning mr-2"
	// 				onClick={() => confirmDeleteProduct(rowData)}
	// 			/>
	// 		</div>
	// 	);
	// };

	const searchDropdownMateriales = (event) => {
		setTimeout(() => {
			let filteredData;
			if (!event.query.trim().length) {
				filteredData = [...listaMateriales];
			} else {
				filteredData = listaMateriales.filter((country) => {
					return country.nombre
						.toLowerCase()
						.includes(event.query.toLowerCase());
				});
			}
			setfilterDropdownMateriales(filteredData);
		}, 150);
	};

	const searchDropdownPlantillas = (event) => {
		setTimeout(() => {
			let filteredData;
			if (!event.query.trim().length) {
				filteredData = [...tableDropdownPlnatillas];
			} else {
				filteredData = tableDropdownPlnatillas.filter((country) => {
					return country.nombre
						.toLowerCase()
						.includes(event.query.toLowerCase());
				});
			}
			setfilterDropdownPlnatillas(filteredData);
		}, 50);
	};

	const tipoMaterialOpciones = [
		{ label: "Plantilla", value: "1" },
		{ label: "Material", value: "2" },
	];

	return (
		<div className='grid'>
			<div className='col-12'>
				<div className='card'>
					<Toast ref={toast} />
					<BarraSuperior
						openNew={openNew}
						label={"Agregar Material"}
					/>
					<pre>{JSON.stringify(productDialog)}</pre>
					<ItemsCapitulodetalle
						capitulo={capitulo}
						cambiopadre={productDialog}
					/>
					<Dialog
						visible={productDialog}
						style={{ width: "50%" }}
						header='Material'
						modal
						className='p-fluid'
						footer={productDialogFooter(hideDialog, saveProduct)}
						onHide={hideDialog}>
						<div className='field col'>
							<label htmlFor='name'>Tipo:</label>
							<Dropdown
								options={tipoMaterialOpciones}
								value={tipoMaterial}
								dropdown
								name='opcionMaterial'
								id='opcionMaterial'
								onChange={(e) => {
									settipoMaterial(e.value);
									let _product = { ...product };
									_product[`codigopartida`] = capitulo.id;
									setProduct(_product);

									// console.log(e.value);
								}}
							/>
							{/* <pre>{JSON.stringify(capitulo)}</pre>
							<pre>{JSON.stringify(product)}</pre> */}
						</div>
						{tipoMaterial === "1" && (
							<div>
								<div className='field col'>
									<label htmlFor='name'>Plantillas:</label>
									<AutoComplete
										value={valueDropdownPlnatillas}
										suggestions={filterDropdownPlnatillas}
										completeMethod={
											searchDropdownPlantillas
										}
										field='nombre'
										dropdown
										name='codigoPlantilla'
										id='codigoPlantilla'
										onChange={(e) => {
											setvalueDropdownPlnatillas(e.value);
											setProduct({
												...product,
												codigoPlantilla: e.value.id,
												codigomaterial: 0,
											});
											// console.log(e.value);
										}}
									/>
								</div>
							</div>
						)}

						{tipoMaterial === "2" && (
							<div>
								<div className='field col'>
									<label htmlFor='name'>Materiales:</label>
									<AutoComplete
										value={valueDropdownMateriales}
										suggestions={filterDropdownMateriales}
										completeMethod={
											searchDropdownMateriales
										}
										field='dataselector'
										dropdown
										name='codigoMaterial'
										id='codigoMaterial'
										onChange={(e) => {
											setvalueDropdownMateriales(e.value);
											// console.log(e.value.precio);
											product.precio = e.value.precio;
											setProduct({
												...product,
												codigomaterial: e.value.id,
												codigoPlantilla: 0,
											});
										}}
									/>
								</div>

								<div className='formgrid grid'>
									<div className='field col'>
										<label htmlFor='precio'>
											Cantidad:
										</label>
										<InputNumber
											id='cantidadMaterial'
											mode='decimal'
											maxFractionDigits={2}
											value={cantidadMaterial}
											onValueChange={(e) =>
												onInputNumberChange(
													e,
													"cantidad"
												)
											}
										/>
									</div>
									<div className='field col'>
										<label htmlFor='precio'>Precio:</label>
										<InputNumber
											id='precio'
											mode='decimal'
											maxFractionDigits={2}
											value={product.precio}
											onValueChange={(e) =>
												onInputNumberChange(e, "precio")
											}
										/>
									</div>
								</div>

								{/* <pre>{JSON.stringify(product)}</pre> */}
							</div>
						)}
					</Dialog>
				</div>
			</div>
		</div>
	);
};
